export enum StopType {
  PICKUP = "P",
  DELIVERY = "D",
  BOTH = "B"
}
